const RETURN_PATH_KEY = 'sshop:social-auth-return-path';

export function setSocialAuthReturnPath(path: string | null): void {
  try {
    if (path?.startsWith('/') && !path.startsWith('//')) {
      sessionStorage.setItem(RETURN_PATH_KEY, path);
    } else {
      sessionStorage.removeItem(RETURN_PATH_KEY);
    }
  } catch {
    // Authentication still works when storage is disabled.
  }
}

export function consumeSocialAuthReturnPath(): string | null {
  try {
    const path = sessionStorage.getItem(RETURN_PATH_KEY);
    sessionStorage.removeItem(RETURN_PATH_KEY);
    return path?.startsWith('/') && !path.startsWith('//') ? path : null;
  } catch {
    return null;
  }
}
